import { useTranslation } from 'react-i18next';

import { LogoutOutline } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Route } from '../../config/router';
import { NavMenuItem } from '../Navigation/NavMenuItem';

const AuthButton = () => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('navigation');
	return (
		<NavMenuItem to={recognizeURL(Route.Logout)} icon={<LogoutOutline />}>
			{t('user_menu.log_out')}
		</NavMenuItem>
	);
};

export default AuthButton;
